import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { AssignmentLoginLink, UserLoginResponse } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function loginLink(config) {
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AssignmentLoginLink)),
    });
    const loginResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(UserLoginResponse)),
    });
    return Object.freeze({
        /**
         * Get a login link and the connected assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.loginLinkId The id of the login link you want to get.
         * @returns The requested login link, which will also contain information about the connected assignment.
         */
        get: async ({ loginLinkId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/login_links/${loginLinkId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Login with the given login link.
         *
         * This will only work when the assignment connected to this link is available, and the lock date has not expired. The received JWT token will only be valid until the 30 minutes after the lock date, and only in the course connected to this link.
         *
         * The scope of the returned token will change in the future, this will not be considered a breaking change.
         *
         * @param arg The arguments to the function.
         * @param arg.loginLinkId The id of the login link you want to use to login.
         * @returns The logged in user and an access token.
         */
        login: async ({ loginLinkId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/login_links/${loginLinkId}/login`, loginResponse.v, undefined);
            return result;
        },
    });
}
